import React from "react";
import { Image } from "react-native";
import { Spacer } from "~/components/Spacer";
import { View } from "~/components/View";
import { styleConstants } from "~/style/styleConstants";
import { useResponsive } from "../live-chat/useResponsive";

export function SectionBokBokDatingApp2Images() {
  const r = useResponsive();

  return (
    <View>
      <View
        style={{
          justifyContent: r("flex-start", "flex-start", "center"),
        }}
      >
        <View
          flexDirectionRow
          centerContent
          style={{ gap: styleConstants.spacingExtraLarge }}
        >
          <View
            style={{ width: r("35%", "25%", "35%"), aspectRatio: 436 / 886 }}
          >
            <Image
              style={{ width: "100%", height: "100%" }}
              source={require("./bokbok-dating-app-01.png")}
            />
          </View>
          <View
            style={{
              width: r("35%", "25%", "35%"),
              aspectRatio: 436 / 886,
              marginTop: 100,
            }}
          >
            <Image
              style={{ width: "100%", height: "100%" }}
              source={require("./bokbok-dating-app-02.png")}
            />
          </View>
        </View>

        <Spacer large />
      </View>
    </View>
  );
}
